export const removePaymentCostBase = ({ execute }) => async (cartId, version, customLineItemId) => execute({
    uri: `/ctp/carts/${cartId}`,
    method: "POST",
    body: { version, actions: [{ action: "removeCustomLineItem", customLineItemId }] },
});
